import { ReactComponent as AdministrarEmpresa } from "../../assets/images/administrar-empresa.svg";
import { ReactComponent as Cliente } from "../../assets/images/cliente.svg";
import { ReactComponent as Usuarios } from "../../assets/images/usuarios.svg";
import { useTranslation } from "react-i18next";

export const useModulesSettings = () => {
    const { t } = useTranslation();

    const MODULES_SETTINGS = [
        {
            id: 0,
            titulo: t("manage_company"),
            descripcion: t("label_data_company"),
            icono: <AdministrarEmpresa style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "settings/manage-company/manage-company",
        },
        {
            id: 2,
            titulo: t("manage_empresa_plataforma"),
            descripcion: t("label_cliente_empresa"),
            icono: <Cliente style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "settings/manage-company-client/manage-company-client",
        },
        {
            id: 3,
            titulo: t("manage_account"),
            descripcion: t("label_manage_account"),
            icono: <Usuarios style={{ width: "40px", height: "40px", marginLeft: "12px" }} />,
            color: "rgba(0, 128, 0, 0.5)",
            href: "settings/manage-account/manage-account",
        },
    ];

    return MODULES_SETTINGS;
};
